import {
  CUSTOMER_IMPLEMENTATION_STAGE,
  CUSTOMER_INSIGHT_ANSWER_STATUS,
  CUSTOMER_PERSONA,
  CUSTOMER_RENEWAL_INTENT,
  CUSTOMER_SPEND_QUESTION,
  CUSTOMER_SPEND_RANGE,
  SPEND_RANGE_VALUE,
  SoftwareExperiencePanelEnum
} from "./enums";

export const SOFTWARE_EXPERIENCE_QUERY_PARAMS = {
  Panel: "panel",
  Source: "source",
  WorkHistoryId: "workHistoryId",
  OpenSoftwareReviewDrawer: "openSoftwareReviewDrawer",
  VendorCompanyId: "vendorCompanyId",
  FromSignUpCampaign: "fromSignUpCampaign",
  Token: "token"
} as const;

export const OPEN_SOFTWARE_REVIEW_DRAWER_TRUE_VALUE = "true";
export const FROM_SIGN_UP_CAMPAIGN_TRUE_VALUE = "true";

export const CLIENT_SOFTWARE_REVIEW_REQUEST_NOT_FOUND_ERROR_CODE = "1462";

export const PersonaOptions = [
  {
    value: CUSTOMER_PERSONA.User,
    title: "userOption",
    description: "userDescription"
  },
  {
    value: CUSTOMER_PERSONA.Influencer,
    title: "influencerOption",
    description: "influencerDescription"
  }
];

export const AdoptionOptions = [
  {
    value: CUSTOMER_IMPLEMENTATION_STAGE.Pilot,
    title: "pilotOption",
    description: "pilotDescription"
  },
  {
    value: CUSTOMER_IMPLEMENTATION_STAGE.LessThan1Year,
    title: "lessThanYearOption",
    description: "lessThanYearDescription"
  },
  {
    value: CUSTOMER_IMPLEMENTATION_STAGE.MoreThan1Year,
    title: "moreThanYearOption",
    description: "moreThanYearDescription"
  },
  {
    value: CUSTOMER_IMPLEMENTATION_STAGE.OffBoarding,
    title: "offBoardingOption",
    description: "offBoardingDescription"
  },
  {
    value: CUSTOMER_IMPLEMENTATION_STAGE.NotSure,
    title: "notSureOption"
  }
];

export const SpendRangeOptions = [
  { value: CUSTOMER_SPEND_RANGE.UpTo10k, title: "spendUpTo10k" },
  {
    value: CUSTOMER_SPEND_RANGE.Between10kAnd20k,
    title: "spendBetween10kAnd20k"
  },
  {
    value: CUSTOMER_SPEND_RANGE.Between20kAnd50k,
    title: "spendBetween20kAnd50k"
  },
  {
    value: CUSTOMER_SPEND_RANGE.Between50kAnd100k,
    title: "spendBetween50kAnd100k"
  },
  { value: CUSTOMER_SPEND_RANGE.MoreThan100k, title: "spendMoreThan100k" }
];

export const SPEND_RANGE_TO_VALUE: Record<
  CUSTOMER_SPEND_RANGE,
  SPEND_RANGE_VALUE
> = {
  [CUSTOMER_SPEND_RANGE.UpTo10k]: SPEND_RANGE_VALUE.UpTo10k,
  [CUSTOMER_SPEND_RANGE.Between10kAnd20k]: SPEND_RANGE_VALUE.Between10kAnd20k,
  [CUSTOMER_SPEND_RANGE.Between20kAnd50k]: SPEND_RANGE_VALUE.Between20kAnd50k,
  [CUSTOMER_SPEND_RANGE.Between50kAnd100k]: SPEND_RANGE_VALUE.Between50kAnd100k,
  [CUSTOMER_SPEND_RANGE.MoreThan100k]: SPEND_RANGE_VALUE.MoreThan100k
};

export const VALUE_TO_SPEND_RANGE: Record<number, CUSTOMER_SPEND_RANGE> = {
  [SPEND_RANGE_VALUE.UpTo10k]: CUSTOMER_SPEND_RANGE.UpTo10k,
  [SPEND_RANGE_VALUE.Between10kAnd20k]: CUSTOMER_SPEND_RANGE.Between10kAnd20k,
  [SPEND_RANGE_VALUE.Between20kAnd50k]: CUSTOMER_SPEND_RANGE.Between20kAnd50k,
  [SPEND_RANGE_VALUE.Between50kAnd100k]: CUSTOMER_SPEND_RANGE.Between50kAnd100k,
  [SPEND_RANGE_VALUE.MoreThan100k]: CUSTOMER_SPEND_RANGE.MoreThan100k
};

export const SpendOptions = [
  {
    value: CUSTOMER_SPEND_QUESTION.Yes,
    title: "yesOption"
  },
  {
    value: CUSTOMER_SPEND_QUESTION.No,
    title: "noOption"
  }
];

export const renewalIntentOptions = [
  {
    value: CUSTOMER_RENEWAL_INTENT.Yes,
    title: "yesOption"
  },
  {
    value: CUSTOMER_RENEWAL_INTENT.No,
    title: "noOption"
  },
  {
    value: CUSTOMER_RENEWAL_INTENT.NotSure,
    title: "notSureOption"
  }
];

export const customerInsightsSortPriority: Record<
  CUSTOMER_INSIGHT_ANSWER_STATUS,
  number
> = {
  [CUSTOMER_INSIGHT_ANSWER_STATUS.Approved]: 1,
  [CUSTOMER_INSIGHT_ANSWER_STATUS.InReview]: 2,
  [CUSTOMER_INSIGHT_ANSWER_STATUS.Pending]: 3,
  [CUSTOMER_INSIGHT_ANSWER_STATUS.Rejected]: 4,
  [CUSTOMER_INSIGHT_ANSWER_STATUS.Declined]: 5,
  [CUSTOMER_INSIGHT_ANSWER_STATUS.Outdated]: 6
};

interface SoftwareExperienceSearchExtras {
  workHistoryId?: string;
}

export const buildSoftwareExperienceSearch = (
  panel: SoftwareExperiencePanelEnum,
  extras?: SoftwareExperienceSearchExtras
): string => {
  const params = new URLSearchParams({
    [SOFTWARE_EXPERIENCE_QUERY_PARAMS.Panel]: panel
  });
  if (extras?.workHistoryId) {
    params.set(
      SOFTWARE_EXPERIENCE_QUERY_PARAMS.WorkHistoryId,
      extras.workHistoryId
    );
  }
  return `?${params.toString()}`;
};

export const OPEN_SOFTWARE_REVIEW_DRAWER_SEARCH = `?${new URLSearchParams({
  [SOFTWARE_EXPERIENCE_QUERY_PARAMS.OpenSoftwareReviewDrawer]:
    OPEN_SOFTWARE_REVIEW_DRAWER_TRUE_VALUE
}).toString()}`;
